import axios from 'axios';
import store from './store';
import md5 from 'md5';

/**
 * 计算输入字符串的CRC32校验码
 *
 * @param inputString 输入字符串
 * @returns 返回计算得到的CRC32校验码
 */
function crc32(inputString) {
  var table = [];
  for (var a = 0, b = 0; a < 256; a++) {
    b = a;
    for (var c = 0; c < 8; c++) {
      b = (b & 1) ? (3988292384 ^ (b >>> 1)) : (b >>> 1);
    }
    table[a] = b;
  }

  var crc = -1;
  for (var i = 0; i < inputString.length; i++) {
    crc = (crc >>> 8) ^ table[(crc ^ inputString.charCodeAt(i)) & 0xFF];
  }

  return ((crc ^ (-1)) >>> 0);
}

export default async (type = 'get', url = '', data = {}, api_type = 1) => {
  const api_url = api_type === 1 ? store.state.req_url : (api_type === 3 ? store.state.req_url3 : store.state.req_url2);
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  // Determine userKey based on API
  const userKey = store.state.user_key || ''

  // Prepare common headers
  const headers = {
    'content-Type': 'application/json; charset=UTF-8',
    'userKey': userKey,
  };

  if (type === 'get') {
    try {
      const response = await axios.get(api_url + url, { headers });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error; // Rethrow the error to allow further error handling outside
    }
  } else {
    // Prepare request data and headers based on api_type
    const params = {
      ...data,
      uUid: store.state.uuid,
      uUserId: store.state.uuserId,
    };

    let timestamp;
    if (api_type === 1) {
      timestamp = new Date().getTime();
      headers['content-Type'] = 'application/x-www-form-urlencoded';
    } else {
      const timestamp_org = Math.trunc(new Date().getTime() / 1000);
      const timestamp_crc = String(crc32(String(timestamp_org))).substring(0, 3);
      timestamp = Number(timestamp_org + timestamp_crc);
    }

    const sign = md5(JSON.stringify(params) + timestamp);
    headers['timestamp'] = timestamp;
    headers['sign'] = sign;
    headers['platform'] = isMobile ? 'vbefMobile' : 'vbefPC';

    if (api_type === 2) {
      headers['vbBusinessId'] = '1';
      headers['vbProjectId'] = '1';
      headers['examineVersionNumber'] = '1';
      headers['imei'] = store.state.uuid;
    }

    // Handle PUT and POST requests
    const method = type === 'put' ? 'put' : 'post';
    try {
      const response = await axios[method](api_url + url, JSON.stringify(params), { headers });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error; // Rethrow the error to allow further error handling outside
    }
  }
};